import { NumberFormatValues } from 'react-number-format'

export function isValidPercentage(values: NumberFormatValues) {
  if (!values.floatValue) {
    return true
  }
  return values.floatValue >= 0 && values.floatValue <= 100
}

export const isValidDecimal = (values: NumberFormatValues) => {
  if (!values.floatValue) {
    return true
  }
  return values.floatValue >= 0 && values.floatValue <= 1
}
